import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { LAWYER } from '@shared/constants/ProfileProductId';
import { useProfileProductId } from '@/shared/stores/ProfileProductId';
import { useBaseLawyerStore } from '@/shared/stores/BaseLawyerStore';
import { useBaseCompanyStore } from '@/shared/stores/BaseCompanyStore';
import { RATING_LINK } from '@shared/constants/Links';
import { TranslationHelper } from '@/shared/helper/TranslationHelper';

export const useBaseProfileStore = defineStore('baseProfileStore', () => {
  const { getTranslationByProductId } = TranslationHelper();
  const { profile } = useBaseLawyerStore();

  const uri = ref('');
  const imagePath = ref('');
  const ratingUri = computed(() => uri.value + RATING_LINK);

  const lawyerStore = useBaseLawyerStore();
  const companyStore = useBaseCompanyStore();
  const { profileProductId } = useProfileProductId();

  const displayedName = computed(() => (profileProductId === LAWYER ? lawyerStore.formattedName : companyStore.name));
  const userId = computed(() => (profileProductId === LAWYER ? lawyerStore.userId : companyStore.companyId));

  const profileProductIdText = computed(() =>
    getTranslationByProductId('profileProductIdText', profileProductId, { profession: profile.profession })
  );

  return {
    uri,
    imagePath,
    displayedName,
    userId,
    ratingUri,
    profileProductIdText,
  };
});
